import { Card, Flex, ProductSummary, Separator, theme, Typography } from '@fe-toolkit/web-components/ssr'

import { ChangePlanPreview, Plan } from '@/api'
import { formatPriceFromPenceToPounds } from '@/utils/formatPrice'

export type ChangePlanComparisonProps = {
  oldPlan: ChangePlanPreview['oldPlan']
  newPlan: ChangePlanPreview['newPlan']
  plan?: Plan
}

export default function ChangePlanComparison({ oldPlan, newPlan, plan }: Readonly<ChangePlanComparisonProps>) {
  const isPromoPlan = !!plan?.promotionalProduct

  return (
    <>
      {oldPlan && (
        <Flex data-testid="confirm-plan-change-old-plan" flexDirection="column" gap={theme.spacing.small}>
          <Typography as="h2" variant="loudBold">
            Old plan
          </Typography>
          <Card backgroundColor="gallery" padding="small">
            <ProductSummary broadband={[oldPlan]} showPrices={true} />
          </Card>
        </Flex>
      )}
      <Flex data-testid="confirm-plan-change-new-plan" flexDirection="column" gap={theme.spacing.small}>
        <Typography as="h2" variant="loudBold">
          New plan
        </Typography>
        <Card backgroundColor="gallery" padding="small">
          <ProductSummary broadband={[newPlan]} showPrices={true} />
          {isPromoPlan && (
            <>
              <Separator my={theme.spacing.small} />
              <Typography as="p" variant="speakUp">
                Monthly payment
              </Typography>
              <Typography as="p" testId="change-plan-confirm-promo-text" variant="speak">
                {formatPriceFromPenceToPounds(Number(plan.monthlyPrice) * 100)}/month for {plan.promotionPeriodInMonths}{' '}
                months then {formatPriceFromPenceToPounds(Number(plan.postPromotionMonthlyPrice) * 100)}/month. Limited
                time offer.
              </Typography>
            </>
          )}
        </Card>
      </Flex>
    </>
  )
}
